import {
  EuiButton,
  EuiButtonEmpty,
  EuiCodeBlock,
  EuiCopy,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiSpacer,
} from "@inscopix/ideas-eui";
import { CallOutError } from "components/CallOutError/CallOutError";

interface ModalDownloadContainerProps {
  name: string;
  label: string;
  tenant: {
    id: number;
    name: string;
    key: string;
  } | null;
  onClose: () => void;
}

export const ModalDownloadContainer = ({
  name,
  label,
  tenant,
  onClose,
}: ModalDownloadContainerProps) => {
  const command = tenant
    ? `ideas containers download ${tenant.key}/${name}:${label}`
    : "";

  return (
    <EuiModal onClose={onClose} style={{ width: 800 }}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>Download Container</EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        {tenant ? (
          <>
            <p>
              This container can be copied to your local machine using the
              following IDEAS CLI command:
            </p>
            <EuiSpacer size="s" />
            <EuiCodeBlock language="sh" isCopyable fontSize="m">
              {command}
            </EuiCodeBlock>
          </>
        ) : (
          <CallOutError />
        )}
      </EuiModalBody>

      <EuiModalFooter>
        <EuiButtonEmpty onClick={onClose}>Cancel</EuiButtonEmpty>

        {tenant !== null && (
          <EuiCopy textToCopy={command}>
            {(copy) => (
              <EuiButton fill onClick={copy}>
                Copy command
              </EuiButton>
            )}
          </EuiCopy>
        )}
      </EuiModalFooter>
    </EuiModal>
  );
};
